import React from 'react'
import {Card, Text} from 'wix-ui-tpa/cssVars'
import {useTranslation} from '@wix/yoshi-flow-editor'
import {Experience} from '@wix/ambassador-table-reservations-v1-experience/types'

import {withMediaStorageUrl} from '../../../../utils/images-gallery'
import {LayoutSize} from '../../../../components-shared/LayoutSizeProvider/types'
import {convertMinutesToHoursAndMinutes} from '../../../../utils/date'
import {ExperienceSchedule} from '../../../../components-shared/ExperienceSchedule'
import {DEFAULT_CURRENCY} from '../../../../utils/constants'
import {ReserveButton} from '../ReserveButton'
import {ExperiencePrice} from '../../../../components-shared/ExperiencePrice'

import {classes, st} from './Header.st.css'

interface Props {
  experience?: Experience
  onReserveClick: () => void
  regionalSettings?: string
  layoutSize: LayoutSize
  showReserveButton: boolean
  timeZone?: string | null
}

export const Header = ({
  experience,
  onReserveClick,
  regionalSettings,
  layoutSize,
  showReserveButton,
  timeZone,
}: Props) => {
  const {t} = useTranslation()
  const imageId = experience?.configuration?.displayInfo?.coverImage?.id
  const backgroundImage = imageId ? `url(${withMediaStorageUrl(imageId)})` : undefined

  const partySizeConfig = experience?.configuration?.onlineReservations?.partySize

  const businessSchedule = experience?.configuration?.onlineReservations?.businessSchedule

  const currency = experience?.currency ?? DEFAULT_CURRENCY

  return (
    <Card className={st(classes.headerContainer, {noImage: !backgroundImage, [layoutSize]: true})}>
      <Card.Container className={st(classes.headerSubContainer)}>
        {backgroundImage ? (
          <div className={st(classes.experienceImage)} style={{backgroundImage}} />
        ) : null}
        <div className={st(classes.headerContent)}>
          <div>
            <Text className={st(classes.experienceName)} tagName="h2">
              {experience?.configuration?.displayInfo?.name}
            </Text>
            <Text className={st(classes.experienceDescription)} tagName="p">
              {experience?.configuration?.displayInfo?.shortDescription}
            </Text>
          </div>
          <div className={st(classes.detailsTable, {oneRow: !backgroundImage})}>
            {businessSchedule && (
              <div className={st(classes.detailsCell)}>
                <Text tagName="p" className={st(classes.detailsText)}>
                  {t(
                    'uou-reservations.experiences-list.duration',
                    convertMinutesToHoursAndMinutes(businessSchedule.durationInMinutes ?? 0),
                  )}
                </Text>
              </div>
            )}
            {businessSchedule && (
              <div className={st(classes.detailsCell)}>
                <ExperienceSchedule
                  businessSchedule={businessSchedule}
                  regionalSettings={regionalSettings}
                  className={st(classes.detailsText)}
                  timeZone={timeZone}
                />
              </div>
            )}

            <div className={st(classes.detailsCell)}>
              <ExperiencePrice
                className={st(classes.detailsText)}
                currency={currency}
                paymentPolicy={experience?.configuration?.paymentPolicy}
              />
            </div>
            {partySizeConfig && (
              <div className={st(classes.detailsCell)}>
                <Text tagName="p" className={st(classes.detailsText)}>
                  {t('uou-experiences.experience-details.party-size.guests-max', {
                    number: partySizeConfig.max,
                  })}
                </Text>
              </div>
            )}
          </div>
          {showReserveButton && (
            <ReserveButton onClick={onReserveClick}>
              {t('uou-reservations.reservations.continue-cta')}
            </ReserveButton>
          )}
        </div>
      </Card.Container>
    </Card>
  )
}
